import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import moment from 'moment';
import style from '@/views/components/cornerMark/style.vue';
import { IPSService } from '@/services/ipsServices';
import realtionProductList from '@/views/components/couponsManager/relationProduct';
import { appEnvConfig } from '@/configs/appConfigs';
export const PageState = [
  { label: '全部', value: 9 },
  { label: '未开始', value: 1 },
  { label: '进行中', value: 2 },
  { label: '已过期', value: 3 },
  { label: '禁用', value: 4 },
];

export enum SORT {
  DEFAULT,
  ASCE,
  DESC,
}

export const element_sort = {
  ascending: SORT.ASCE,
  descending: SORT.DESC,
};

@Component({
  mixins: [style],
})
export default class CornerMark extends Vue {
  /**
   * 角标名
   * @type {number}
   */
  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 每页显示数量
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总数
   * @type {number}
   */
  public totalCount: number = null;

  /**
   * 关键词
   * @type {string}
   */
  public keywords = '';

  // 角标状态
  public pageState = 9;

  // 列表数据
  public tableData: Array<any> = [];

  // 批量选择的数组
  public selectedList: Array<any> = [];

  // 排序
  public sort = 0;

  // 加载状态
  loadingState = false;

  // 搜索角标名
  handleSearch() {
    this.page = 1;
    this.getList();
  }

  // 筛选角标状态
  stateChange(val) {
    this.page = 1;
    this.pageState = val;
    this.getList();
  }

  // 新建角标
  createCorner() {
    this.$emit('status', 'create', {});
  }

  /**
   * 切换页码
   * @param {number} val
   */
  onPageChange(val: number): void {
    this.page = val;
    this.getList();
  }

  /**
   * 切换每页显示数量
   * @param {number} val
   */
  onPageSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getList();
  }

  // 编辑
  editOperate(val, id) {
    this.$emit('status', 'edit', { type: val, tagId: id });
  }

  // 生命周期 创建前
  created() {
    this.getList();
  }

  // 列表渲染
  getList() {
    const loading = this.$loading({
      lock: true,
      text: '请稍等...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
      target: '.categoryConfig',
    });
    const params = {
      siteId: Number(this.$route.params.siteId),
      status: this.pageState,
      pageSize: this.pageSize,
      page: this.page,
      keyword: this.keywords,
      state: 9,
      sort: this.sort,
    };
    IPSService.tagMappingList({ postParams: params }).then((response) => {
      loading.close();
      this.tableData = response.list;
      this.totalCount = response.count;
    });
  }

  // 删除条目
  deleteItem(id) {
    const tagIds = [];
    tagIds.push(id);
    const params = {
      siteId: Number(this.$route.params.siteId),
      state: -1,
      tagIds,
    };
    this.$confirm('确定要将这条数据删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      IPSService.tagMappingUpdateState({ postParams: params }).then((response) => {
        if (response.result) {
          this.$message({
            message: '删除成功',
            type: 'success',
          });
          this.getList();
        }
      });
    });
  }

  // 禁用、启用角标
  operateItem(id, type) {
    const tagIds = [];
    tagIds.push(id);
    const params = {
      siteId: Number(this.$route.params.siteId),
      state: type == 'start' ? 1 : 0,
      tagIds,
    };
    this.$confirm(`确定${type == 'start' ? '启用' : '禁用'}这条数据吗`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      IPSService.tagMappingUpdateState({ postParams: params }).then((response) => {
        if (response.result) {
          this.$message({
            message: `${type == 'start' ? '启用' : '禁用'}成功`,
            type: 'success',
          });
          this.getList();
        }
      });
    });
  }

  /**
   * 打开关联商品弹窗列表
   * @param {number} tagId
   * @returns null
   */
  openRelationPro(tagId: number): void {
    realtionProductList.open({
      tagId,
      service: 'tag',
      siteId: Number(this.$route.params.siteId),
      sendToId: appEnvConfig.NODE_ENV + this.$store.state.empCode + Date.now(),
    });
  }

  // 批量选择
  onSelected(val) {
    const tagsId = [];
    val.map((item, index) => {
      tagsId.push(item.tagId);
    });
    this.selectedList = tagsId;
  }

  // 排序
  onSortChange(v) {
    this.page = 1;
    this.sort = element_sort[v.order];
    this.getList();
  }

  // 批量操作
  banchOperate(type) {
    if (!this.selectedList.length) {
      return;
    }
    const params = {
      siteId: Number(this.$route.params.siteId),
      state: type == 'start' ? 1 : type == 'ban' ? 0 : -1,
      tagIds: this.selectedList,
    };
    this.$confirm(`确定批量${type == 'start' ? '启用' : type == 'ban' ? '禁用' : '删除'}这些数据吗`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      IPSService.tagMappingUpdateState({ postParams: params }).then((response) => {
        if (response.result) {
          this.$message({
            message: `批量${type == 'start' ? '启用' : type == 'ban' ? '禁用' : '删除'}成功`,
            type: 'success',
          });
          this.getList();
        }
      });
    });
  }

  /**
   *
   * @param h
   * @param val
   */
  renderTableBtn(h, val) {
    return (
      <div>
        <span class="scopeSpan" onClick={this.editOperate.bind(this, 'edit', val.tagId)}>
          编辑
        </span>
        {val.state === 0 ? (
          <span class="scopeSpan" onClick={this.operateItem.bind(this, val.tagId, 'start')}>
            启用
          </span>
        ) : (
          <span class="scopeSpan" onClick={this.operateItem.bind(this, val.tagId, 'ban')}>
            禁用
          </span>
        )}
        <span class="scopeSpan" onClick={this.deleteItem.bind(this, val.tagId)}>
          删除
        </span>
      </div>
    );
  }

  render(h) {
    return (
      <div class="cornermarkPage">
        {/* 搜索 */}
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keywords} placeholder="请输入角标名" onEnter={this.handleSearch.bind(this)} />
            <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)} />
          </div>
          <el-select v-model={this.pageState} onChange={val => this.stateChange(val)}>
            {PageState.map((v) => {
              return <el-option label={v.label} value={v.value} />;
            })}
          </el-select>
        </div>
        {/* 表格 */}
        <div class="tableWrapper" style="calc(100% - 90px)">
          <el-table
            height={'calc(100% - 0px)'}
            // ref="cTable"
            data={this.tableData}
            v-loading={this.loadingState}
            // on-sort-change={this.onSortChange.bind(this)}
            on-selection-change={this.onSelected.bind(this)}
            on-sort-change={this.onSortChange.bind(this)}
            element-loading-text="加载中"
            tooltip-effect="light">
            <el-table-column type="selection" width="50" align="center" fixed="left" show-overflow-tooltip={true} />
            <el-table-column type="index" label="#" width="50" align="center" fixed="left" show-overflow-tooltip={true} />
            <el-table-column prop="tagName" label="名称" width="120" align="left" fixed="left" show-overflow-tooltip={true} />
            <el-table-column
              prop="tagPlace"
              label="位置"
              width="60"
              align="left"
              show-overflow-tooltip={true}
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return (
                      <div>
                        {scope.row.tagPlace == 1 && <span>左上角</span>}
                        {scope.row.tagPlace == 2 && <span>右上角</span>}
                        {scope.row.tagPlace == 5 && <span>底部</span>}
                      </div>
                    );
                  },
                },
              }}
            />
            <el-table-column
              prop="image"
              label="图片"
              width="80"
              align="left"
              fixed="left"
              show-overflow-tooltip={true}
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <div>{scope.row.tagPic == 5 ? <img class="p-pic wid-30 hei-15" src={scope.row.tagPic} /> : <img class="p-pic wid-30 hei-15" src={scope.row.tagPic} />}</div>;
                  },
                },
              }}
            />
            <el-table-column
              prop="productNum"
              sortable="custom"
              label="关联商品"
              align="right"
              width="120"
              show-overflow-tooltip={true}
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return (
                      <div>
                        {scope.row.productNum > 0 && (
                          <el-button class="r-pa-0" type="text" on-click={this.openRelationPro.bind(this, scope.row.tagId)}>
                            {scope.row.productNum}
                          </el-button>
                        )}
                        {scope.row.productNum === 0 && <span>{scope.row.productNum}</span>}
                      </div>
                    );
                  },
                },
              }}
            />
            <el-table-column
              prop="beginTime"
              label="活动周期"
              width="280"
              show-overflow-tooltip={true}
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return scope.row.beginTime === 0 ? (
                      <p>不限</p>
                    ) : (
                      <p>
                        {moment(scope.row.beginTime * 1000).format('YYYY-MM-DD HH:mm')}&nbsp;~&nbsp;
                        {moment(scope.row.endTime * 1000).format('YYYY-MM-DD HH:mm')}
                      </p>
                    );
                  },
                },
              }}
            />
            <el-table-column
              prop="status"
              label="状态"
              align="left"
              show-overflow-tooltip={true}
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return (
                      <div>
                        {scope.row.status === 1 && <span>未开始</span>}
                        {scope.row.status === 2 && <span>进行中</span>}
                        {scope.row.status === 3 && <span>已过期</span>}
                        {scope.row.status === 4 && <span>禁用</span>}
                      </div>
                    );
                  },
                },
              }}
            />
            <el-table-column
              prop="state"
              label="是否启用"
              align="left"
              show-overflow-tooltip={true}
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return (
                      <div>
                        {scope.row.state === 1 && <span>启用</span>}
                        {scope.row.state === 0 && <span>禁用</span>}
                      </div>
                    );
                  },
                },
              }}
            />
            <el-table-column prop="empName" label="更新人" align="left" />
            <el-table-column
              prop="updateTime"
              label="更新时间"
              align="left"
              width="180"
              show-overflow-tooltip={true}
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <span>{moment(scope.row.updateTime * 1000).format('YYYY-MM-DD HH:mm')}</span>;
                  },
                },
              }}
            />
            <el-table-column
              prop=""
              label="操作"
              align="center"
              width="200"
              fixed="right"
              show-overflow-tooltip={true}
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return this.renderTableBtn(h, scope.row);
                  },
                },
              }}
            />
          </el-table>
        </div>
        {/* 底部 分页 按钮操作 */}
        <div class="bottomWrapper hei-26 bg-white" style="z-index:99;bottom:5px;">
          <div>
            <el-button type="primary" onClick={this.createCorner.bind(this)}>
              新建角标
            </el-button>
            <span class={['scopeSpan', !this.selectedList.length && 'disabled']} onClick={this.banchOperate.bind(this, 'delete')}>
              批量删除
            </span>
            <span class={['scopeSpan', !this.selectedList.length && 'disabled']} onClick={this.banchOperate.bind(this, 'start')}>
              批量启用
            </span>{' '}
            <span class={['scopeSpan', !this.selectedList.length && 'disabled']} onClick={this.banchOperate.bind(this, 'ban')}>
              批量禁用
            </span>
          </div>
          <div class="pagination">
            <el-pagination
              on-size-change={this.onPageSizeChange}
              on-current-change={this.onPageChange}
              current-page={this.page}
              page-sizes={[10, 30, 60, 100]}
              page-size={this.pageSize}
              layout="total, sizes, prev, pager, next, jumper"
              total={this.totalCount}
            />
          </div>
        </div>
      </div>
    );
  }
}
